<template>
  <div class="class-list">
    <GlobalInfoBar
      title="商品管理"
      content="创建或上架二手优品到门店端小程序"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From/>
      </div>
      <Table/>
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import _api from "@/utils/request";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {
      channelSelectList: [],
      merchantSelectList: [],
      allMerchantSelectList: []
    };
  },
  created() {
    
  },
  methods: {
  },
};
</script>

<style>
</style>